import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_Resource, ResourceManagerPermissionKeys, ResourcePermissionKeys } from '@app/hcs-shared';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
export const dispatch_onResourcesUpdated = new ThunderDispatcherV3('__onResourcesUpdated');
export class ModuleFE_Resource_Class extends ModuleFE_BaseApi {
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => ({ _id: i._id, uiLabel: i.label }))
        }]);
    __searchFilterMapper = (item) => [item.label];
    permissions;
    constructor() {
        super(DBDef_Resource, dispatch_onResourcesUpdated);
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(ResourceManagerPermissionKeys),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(ResourcePermissionKeys)
        };
    }
}
export const ModuleFE_Resource = new ModuleFE_Resource_Class();
//# sourceMappingURL=ModuleFE_Resource.js.map